import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/index';
import { ActivatedRoute, Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { User } from '../../../auth/user.model';
import { Reservation } from '../../reservation.model';
import { ReservationService } from '../../reservation.service';
import { AuthService } from '../../../auth/auth.service';
import { UIService } from '../../../shared/ui.service';
import { Material, Size } from '../../../order/order.model';
import { OrderService } from '../../../order/order.service';
import { StorageService } from '../../../storage/storage.service';
import { Client } from '../../../client/client';
import { ClientService } from '../../../client/client.service';
import { Permission } from '../../../access/access.service';

@Component({
  selector: 'app-reservation-details',
  templateUrl: './reservation-details.component.html',
  styleUrls: ['./reservation-details.component.css'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({backgroundColor: 'yellow', opacity: 0, height: '0px'}),
        animate(2000)
      ])
    ])
  ]
})

export class ReservationDetailsComponent implements  OnInit, OnDestroy {
  user: User;
  client: Client;
  reservation: Reservation;
  isLoading = false;
  addressFormGroup: FormGroup;
  binFormGroup: FormGroup;
  deliveryDateFormGroup: FormGroup;

  isNew = true;

  priceInformationMessage = '';

  largeBinIds = [1, 2, 6, 7, 8, 9];
  threeTonsBinIds = [2, 5, 6];
  heavyMaterialIds = [1, 5, 6, 10];

  selectedMaterialReview = 'Aucun';
  selectedBinSizeReview = 'Aucun';
  addressReview = 'Aucun';
  deliveryDateReview;
  deliveryInformationReview = 'Aucun';
  currentLanguage = 'en';

  lat: number = 45.5017;
  lng: number = -73.5673;
  daysComplete = {
    '2019': [181, 182, 183, 151, 146, 21],
    '2020': [152, 136, 121]
  };

  materials = [];
  binSizes = [];
  binSizesFull = [];
  binSizesHeavy = [];

  now = moment();

  price: number = 0;
  agreed: boolean = false;


  private loadingSubscription: Subscription;
  private selectedProjectSubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private reservationService: ReservationService,
    private orderService: OrderService,
    private authentication: AuthService,
    private uiService: UIService,
    private _formBuilder: FormBuilder,
    private _ref: ChangeDetectorRef,
    private localStorage: StorageService,
    private clientService: ClientService
  ) { }

  minimumDate = this.now.add(1, 'days');

  myFilter = (momentDate: moment.Moment): boolean => {
    const day = momentDate.day();
    if (day === 0 || day === 6) {
      console.log('is sunday or saturday');
      return false;
    }
    const dayOfYear = momentDate.dayOfYear();
    const year = momentDate.year();
    const dayCompleteList =  this.daysComplete[year];

    if (dayCompleteList !== undefined && dayCompleteList.indexOf(dayOfYear) !== -1) {
      console.log('in list');
      return false;
    }
    return true;
  }

  setAddress(event) {
    this.lat = Number(event.geometry.location.lat());
    this.lng = Number(event.geometry.location.lng());
    this._ref.detectChanges();
  }

  calculatePrice(sizeWantedId: number, materialId: number) {
    let price = 0;
    const webPriceAdjustment = 0;
    if (materialId === 11 || materialId === 4) {
      if(sizeWantedId === 3){
        price = 485;
      } else if (sizeWantedId === 1){
        price = 555;
      } else if (sizeWantedId === 2){
        price = 625;
      } else if (sizeWantedId === 5){
        price = 685;
      } else if (sizeWantedId === 6){
        price = 895;
      }
    }
    if (materialId === 1 || materialId === 10) {
      price = 625;
    }
    if (materialId === 5 || materialId === 6) {
      price = 525;
    }

    if (sizeWantedId === 5) {
      if (materialId === 1) {
        price = 875;
      }
      if (materialId === 5) {
        price = 725;
      }
      if (materialId === 6) {
        price = 725;
      }
    }
    if (materialId === 11 && sizeWantedId === 9) {
        price = 225;
    }
    if (materialId === 11 && sizeWantedId === 7) {
        price = 345;
    }
    if (materialId === 11 && sizeWantedId === 8) {
        price = 385;
    }
    if (price > webPriceAdjustment){
      price = price - webPriceAdjustment;
    }
    return price;
  }

  ngOnInit() {

    this.currentLanguage = this.localStorage.getPreferredLanguage();
    this.selectedProjectSubscription = this.uiService.selectedProjectChanged.subscribe(projectId => {
     const hasAccess = this.validateAccessToData(projectId);
     if(!hasAccess){
       this.router.navigate(['/dashboard']);
     }
    });



    this.addressFormGroup = this._formBuilder.group({
      address: ['', Validators.required]
    });

    this.deliveryDateFormGroup = this._formBuilder.group({
      deliveryDate: [{disabled: true}, Validators.required]
    });

    this.binFormGroup = this._formBuilder.group({
      material: ['', Validators.required],
      size_wanted: ['', Validators.required],
      delivery_information: ['']
    });

    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
    this.user = this.authentication.getUser();

    this.getMaterials();
    this.getBinSizes();
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if(id !== 'new'){
        this.isNew = false;
        this.agreed = true;
      }
      console.log(id);
      this.reservationService.getReservationById(this.user.token, id).subscribe((result: Reservation) => {
        this.reservation = result;
        this.lat = this.reservation.latitude;
        this.lng = this.reservation.longitude;
        this.addressFormGroup.setValue({address: this.reservation.address});
        this.deliveryDateFormGroup.setValue({deliveryDate: moment(this.reservation.delivery_date)});
        this.setBinSizesByMaterialId(this.reservation.material.id);
        this.price = this.calculatePrice(this.reservation.size_wanted.id, this.reservation.material.id);
        this.binFormGroup.setValue({
          size_wanted: this.reservation.size_wanted.id,
          material: this.reservation.material.id,
          delivery_information: this.reservation.delivery_information
        });
        this.uiService.loadingStateChanged.next(false);
      });
      this.clientService.getProfile(this.user.token).subscribe((response: Client) => {
        this.client = response;
    });


    });
  }

  validateAccessToData(projectId) {
    return this.authentication.hasAccessToProject(projectId, Permission.ADMIN);
  }

  getMaterials() {
    this.orderService.getMaterials(this.user.token).subscribe((response: [Material]) => {
      this.materials = response;
      this.uiService.loadingStateChanged.next(false);
    });
  }

  getBinSizes() {
    this.orderService.getBinsizes(this.user.token).subscribe((response: [Size]) => {
      this.createSizesFiltered(response);
      this.uiService.loadingStateChanged.next(false);
    });
  }

  createSizesFiltered(binSizes) {
    for (const binSize of binSizes) {
      let formattedBinSizes = {
        'id': binSize.id,
        'name': binSize.name,
        'disabled': false
      };
      this.binSizesFull.push(formattedBinSizes);

      if (this.largeBinIds.includes(binSize.id)) {
        formattedBinSizes = {
          'id': binSize.id,
          'name': binSize.name + ' ( Trop lourd )',
          'disabled': true
        };
      } else {
        formattedBinSizes = {
          'id': binSize.id,
          'name': binSize.name,
          'disabled': false
        };
      }
      this.binSizesHeavy.push(formattedBinSizes);
    }
  }

  setBinSizesByMaterialId(selectedMaterialId) {
    if (this.heavyMaterialIds.includes(selectedMaterialId)) {
      this.binSizes = this.binSizesHeavy;
    } else {
      this.binSizes = this.binSizesFull;
    }
  }

  getSelectedMaterial() {
    const lookingForId = this.binFormGroup.value.material;
    for (const material of this.materials) {
      if (material.id === lookingForId) {
        return material.name;
      }
    }
    return 'Aucun';
  }

  getSelectedBinSize() {
    const lookingForId = this.binFormGroup.value.size_wanted;
    for (const size of this.binSizes) {
      if (size.id === lookingForId) {
        return size.name;
      }
    }
    return 'Aucun';
  }

  onSelectionChange(event) {
    console.log(event);
    if (event.selectedIndex === 3) {
      this.selectedBinSizeReview = this.getSelectedBinSize();
      this.selectedMaterialReview = this.getSelectedMaterial();
      this.deliveryDateReview = this.deliveryDateFormGroup.value.deliveryDate;
      this.addressReview = this.addressFormGroup.value.address;
      this.deliveryInformationReview = this.binFormGroup.value.delivery_information;
    }
  }

  onMaterialSelectionChanged(event) {
    const selectedMaterialId = event.value;
    this.setBinSizesByMaterialId(selectedMaterialId);
    this.binFormGroup.patchValue({'size_wanted': null});
    this.price = this.calculatePrice(this.binFormGroup.value.size_wanted, this.binFormGroup.value.material);
    this.binFormGroup.patchValue({'price': this.price});
  }

  getPriceInformationMessage(selectedMaterialId, selectedSizeId) {
    let message = '';
    if (selectedMaterialId !== 'Aucun' && selectedSizeId !== 'Aucun') {
      if (this.heavyMaterialIds.includes(selectedMaterialId)) {
        message = '3/4 du conteneur maximum 7 tonnes maximum';
      } else {
        if (this.threeTonsBinIds.includes(selectedSizeId)) {
          message = '3 tonnes inclus - 7 tonnes maximum.';
        } else {
          message = '2 tonnes inclus - maximum 7 tonnes';
        }
      }
    }
    return message;
  }

  onBinSizeSelectionChanged(event) {
    const selectedbinSizeId = event.value;
    this.price = this.calculatePrice(this.binFormGroup.value.size_wanted, this.binFormGroup.value.material);
    this.priceInformationMessage = this.getPriceInformationMessage(this.binFormGroup.value.material,
      this.binFormGroup.value.size_wanted);
    this.binFormGroup.patchValue({'price': this.price});
  }

  createOrUpdateReservation() {
    let reservationsId = -1;
    if (this.reservation !== undefined && this.reservation.id !== undefined) {
      reservationsId = this.reservation.id;
    }

    const deliveryDate = this.deliveryDateFormGroup.value.deliveryDate.set({hour:6})

    const reservation: Reservation = {
        'address': this.addressFormGroup.value.address,
        'id': reservationsId,
        'longitude': this.lng,
        'latitude': this.lat,
        'delivery_date': deliveryDate.toJSON(),
        'size_wanted': this.binFormGroup.value.size_wanted,
        'material': this.binFormGroup.value.material,
        'delivery_information': this.binFormGroup.value.delivery_information
      };
    if (this.reservation === undefined) {
      this.reservationService.createReservation(this.user.token, reservation).subscribe((response: Reservation) => {
        this.uiService.loadingStateChanged.next(false);
        this.router.navigate(['/reservations']);
      });
    } else {
      this.reservationService.updateReservation(this.user.token, reservation).subscribe((response: Reservation) => {
        this.uiService.loadingStateChanged.next(false);
        this.router.navigate(['/reservations']);
      });
    }
    console.log(this.reservation);
  }

  ngOnDestroy(): void {
    this.loadingSubscription.unsubscribe();
    this.selectedProjectSubscription.unsubscribe();
  }
}
